import { AngleLeftIcon } from 'components/icons';
import styled from 'styled-components';

export default styled(AngleLeftIcon)`
  transform: rotate(180deg);
`;
